/* No dependencies, tracking, or external requests beyond the Shopify cart. */
(() => {
  function mount(root) {
    if (root.dataset.pnMounted) return;
    root.dataset.pnMounted = 'true';
    const slides = [...root.querySelectorAll('[data-pn-slide]')];
    const thumbs = [...root.querySelectorAll('[data-pn-thumb]')];
    let index = 0;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const count = root.querySelector('[data-pn-count]');
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    }
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    root.querySelector('[data-pn-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-pn-next]')?.addEventListener('click', () => show(index + 1));
    const gallery = root.querySelector('.pn-gallery');
    gallery?.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); thumbs[index]?.focus();
      }
    });
    let startX = null;
    root.querySelector('.pn-gallery-stage')?.addEventListener('touchstart', event => { startX = event.touches[0].clientX; }, {passive: true});
    root.querySelector('.pn-gallery-stage')?.addEventListener('touchend', event => {
      if (startX !== null && Math.abs(event.changedTouches[0].clientX - startX) > 45) show(index + (event.changedTouches[0].clientX < startX ? 1 : -1));
      startX = null;
    }, {passive: true});
    const form = root.querySelector('[data-pn-form]');
    if (!form) return;
    const inputs = [...form.querySelectorAll('input[name="id"]')];
    const buttons = [...root.querySelectorAll('[data-pn-atc]')];
    const mainButton = form.querySelector('[data-pn-atc]');
    const label = form.querySelector('[data-pn-atc-label]');
    const error = form.querySelector('[data-pn-error]');
    let pending = false;
    function select() {
      const selected = inputs.find(input => input.checked && !input.disabled);
      buttons.forEach(button => { button.disabled = !selected || pending; });
      if (!selected) return;
      root.querySelectorAll('[data-pn-price], [data-pn-sticky-price]').forEach(node => { node.textContent = selected.dataset.money; });
      const compare = Number(selected.dataset.compare);
      const price = Number(selected.dataset.price);
      const compareNode = root.querySelector('[data-pn-compare]');
      const sale = root.querySelector('[data-pn-sale]');
      compareNode.hidden = compare <= price;
      sale.hidden = compare <= price;
      compareNode.textContent = selected.dataset.compareMoney;
      if (compare > price) sale.textContent = `SAVE ${Math.round((compare - price) / compare * 100)}%`;
      // Keep the current variant addressable without losing any campaign query parameters.
      if (!root.dataset.pnPreview && window.location.pathname.includes('/products/')) {
        const url = new URL(window.location.href); url.searchParams.set('variant', selected.value); window.history.replaceState({}, '', url);
      }
    }
    inputs.forEach(input => input.addEventListener('change', select));
    select();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending) return;
      error.hidden = true;
      const selected = inputs.find(input => input.checked && !input.disabled);
      if (!selected) return;
      if (root.dataset.pnPreview) {
        error.textContent = 'Local design preview — no order was placed. The installed theme uses Shopify’s cart and checkout.';
        error.hidden = false;
        return;
      }
      pending = true;
      const oldLabel = label.textContent;
      label.textContent = 'ADDING…';
      buttons.forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(root.dataset.cartAdd, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: selected.value, quantity: 1}]}),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This kit could not be added. Please try again.');
        window.location.assign(root.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure instanceof Error ? failure.message : 'We could not add your kit. Please try again.';
        error.hidden = false; error.scrollIntoView({block: 'nearest', behavior: 'smooth'});
      } finally {
        pending = false; label.textContent = oldLabel; select();
      }
    });
    const sticky = root.querySelector('[data-pn-sticky]');
    if ('IntersectionObserver' in window && sticky && mainButton) {
      const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; });
      observer.observe(mainButton);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      }, {once: true});
    }
  }
  function init(scope = document) { scope.querySelectorAll('[data-pn-product]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
